import { Stack, Typography } from "@mui/material";

import {
  AchPaymentMethod,
  CreditCardPaymentMethod,
} from "@covertree/agent-portal-graphql";
import { Button } from "@covertree/ui";
import { Modal } from "@covertree/ui";
import {
  isCreditCardPaymentMethod,
  mapAchPaymentMethodName,
  mapCreditCardPaymentMethodExpiration,
  mapCreditCardPaymentMethodName,
} from "../../../../utils";

type PaymentMethodType = CreditCardPaymentMethod | AchPaymentMethod;

interface Props {
  method?: PaymentMethodType;
  isLoading?: boolean;
  onClose(): void;
  onRemove(): void;
}
export function RemoveCreditCardModal({
  method,
  isLoading,
  onClose,
  onRemove,
}: Props) {
  const paymentMethodName = method
    ? isCreditCardPaymentMethod(method)
      ? mapCreditCardPaymentMethodName(method)
      : mapAchPaymentMethodName(method)
    : undefined;

  return (
    <Modal
      maxWidth="sm"
      title="Remove this payment method?"
      disableClose={isLoading}
      open={!!method}
      onClose={onClose}>
      {method && (
        <Stack>
          <Typography>{paymentMethodName}</Typography>
          {isCreditCardPaymentMethod(method) && (
            <Typography variant="body2" color="text.disabled">
              {mapCreditCardPaymentMethodExpiration(method)}
            </Typography>
          )}
        </Stack>
      )}
      <Stack mt={5} direction="row" spacing={1}>
        <Button
          loading={isLoading}
          disabled={isLoading}
          onClick={onRemove}
          color="error">
          Remove
        </Button>
        <Button variant="outlined" disabled={isLoading} onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Modal>
  );
}
